import { AuctionType } from "./auctionType";
import { PropertyFeatures } from "./propertyFeatures";
import { PropertyType } from "./propertyType";
import { SaleType } from "./saleType";
import { State } from "./state";

export class PropertyFilterParameters{
    public clients?:number[]; //not set in property filter component right now
    public noClientAssigned?: boolean;
    public judges?:number[]; //not set in property filter component right now
    public assetManagers?:string[]; //not set in property filter component right now
    public attorneys?:string[]; //not set in property filter component right now
    public propertyManagers?:string[]; //not set in property filter component right now
    public auctionTypes?: AuctionType[];
    public propertyTypes?:PropertyType[];
    public states?:State[];
    public saleTypes?:SaleType[]; 
    public propertyFeatures?:PropertyFeatures;
    public propertySearch?:PropertySearch;
    public propertyPhases?: number[]; 

    public clear(){
        this.auctionTypes=undefined;
        this.propertyTypes=undefined;
        this.states=undefined;
        this.saleTypes=undefined;
        this.clients=undefined;
        this.judges=undefined;
        this.assetManagers=undefined;
        this.propertyManagers=undefined;
        this.attorneys=undefined;
        this.propertyFeatures=undefined;
        this.propertySearch=undefined;
        this.propertyPhases=undefined;
    }

    get filterIsSet(){
        return this.auctionTypes?.length || this.propertyTypes?.length || this.states?.length || this.saleTypes?.length 
        || this.propertyFeatures?.definedFeatures || this.propertySearch!=undefined || this.propertyPhases?.length 
        || this.clients?.length || this.judges?.length || this.assetManagers?.length || this.attorneys?.length
        || this.propertyManagers?.length;
    }
}

export class PropertySearch{
    public searchString:string|undefined;
    public propertyIds:number[]|undefined;
    public goDirect:boolean=false; //set to true if routing shall go directly to first propertyId in array
    constructor(searchString:string|undefined,propertyIds:number[]|undefined){
        this.searchString=searchString;
        this.propertyIds=propertyIds;
    }
}